import { CSSProperties, FC, ReactNode } from 'react';
import { Card as CustomCard } from 'primereact/card';

type CardProps = {
  children: ReactNode;
  cardStyle?: CSSProperties;
  className?: string;
};

const Card: FC<CardProps> = ({ cardStyle, className, children }) => {
  return (
    <CustomCard
      unstyled
      className={`bg-black rounded-[3.07px] p-3 ${className}`}
      style={{ ...cardStyle }}
    >
      {children}
    </CustomCard>
  );
};

export default Card;
